import DateBox from 'devextreme-react/date-box'
import {usePeriod} from '../../contexts/period'
import {calendarOptions, useInitPeriod} from './select-period-shared'

const SelectPeriodStart = ({ style, initPeriod = true }) => {
    const { periodStart, setPeriodStart } = usePeriod()
    useInitPeriod(initPeriod)

    return (
        <div style={{...style }}>
            <DateBox
                labelMode={'floating'}
                label={'Период начала:'}
                calendarOptions={calendarOptions}
                value={periodStart}
                onValueChange={setPeriodStart}
                openOnFieldClick={true}
                displayFormat='MM.yyyy'
                useMaskBehavior={true}
            />
        </div>
    )
}

export default SelectPeriodStart
